{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/BRADEN",
	"name": "BRADEN",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Échelle de Braden",
	"purpose": "Évaluation du risque d’escarres",
	"description": "Le score total pour ces six items varie entre 6 et 23. Plus le score est élevé, plus le risque d’escarres est faible. Les patients ayant un score inférieur à 17 sont considérés comme à risque de développer des escarres.",
	"item": [
		{
			"linkId": "10200",
			"text": "Perception Sensorielle",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10201",
						"display": "Complètement limitée"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10202",
						"display": "Très limitée"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10203",
						"display": "Légèrement limitée"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "10204",
						"display": "Aucune atteinte"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10200_helpText",
					"text": "Capacité de répondre d’une manière significative à l’inconfort causé par la pression.",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "Capacité de répondre d’une manière significative à l’inconfort causé par la pression.<br/><br/>- <b>Complètement limitée</b>: Absence de réaction (ne gémit pas, ne sursaute pas, n’a pas de réflexe de préhension) aux stimuli douloureux, dû à une diminution du niveau de conscience ou à la sédation. -OU- A une capacité limitée de ressentir la douleur ou l’inconfort sur la majeure partie de son corps.<br/><br/>- <b>Très limitée</b>: Répond seulement aux stimuli douloureux. Ne peut communiquer l’inconfort que par des gémissements ou de l’agitation. -OU- A une altération sensorielle qui limite la capacité de ressentir la douleur ou l’inconfort sur la moitié de son corps.<br/><br/>- <b>Légèrement limitée</b>: Répond aux ordres verbaux, mais ne peut pas toujours communiquer l’inconfort ou le besoin d’être tourné. -OU- A une certaine altération sensorielle qui limite sa capacité de ressentir la douleur ou l’inconfort dans un ou deux de ses membres.<br/><br/>- <b>Aucune atteinte</b>: Répond aux ordres verbaux. N’a aucun déficit sensoriel qui pourrait limiter sa capacité de ressentir ou d’exprimer la douleur ou l’inconfort."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		},
		{
			"linkId": "10300",
			"text": "Humidité",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10301",
						"display": "Constamment humide"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10302",
						"display": "Très humide"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10303",
						"display": "Occasionnellement humide"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "10304",
						"display": "Rarement humide"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10300_helpText",
					"text": "Le degré d’humidité auquel la peau est exposée.",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "Le degré d’humidité auquel la peau est exposée.<br/><br/>- <b>Constamment humide</b>: La peau est presque constamment humide à cause de la transpiration, de l’urine, etc. La moiteur est notée à chaque fois que la personne est changée de position.<br/><br/>- <b>Très humide</b>: La peau est souvent mais pas toujours humide. La literie doit être changée au moins une fois par quart de travail.<br/><br/>- <b>Occasionnellement humide</b>: La peau est occasionnellement humide nécessitant un changement de literie additionnel environ une fois par jour.<br/><br/>- <b>Rarement humide</b>: La peau est habituellement sèche. La literie est changée aux intervalles habituels."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		},
		{
			"linkId": "10400",
			"text": "Activité",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10401",
						"display": "Alité"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10402",
						"display": "Confinement au fauteuil"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10403",
						"display": "Marche à l’occasion"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "10404",
						"display": "Marche fréquemment"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10400_helpText",
					"text": "Le degré d’activité physique.",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "Le degré d’activité physique.<br/><br/>- <b>Alité</b>: Confinement au lit.<br/><br/>- <b>Confinement au fauteuil</b>: La capacité de marcher est très limitée ou inexistante. Ne peut supporter son propre poids et/ou a besoin d’aide pour s’asseoir au fauteuil ou au fauteuil roulant.<br/><br/>- <b>Marche à l’occasion</b>: Marche occasionnellement pendant la journée, mais sur de très courtes distances, avec ou sans aide. Passe la plupart de chaque quart de travail au lit ou au fauteuil.<br/><br/>- <b>Marche fréquemment</b>: Marche hors de la chambre au moins deux fois par jour et dans la chambre au moins une fois chaque deux heures en dehors des heures de sommeil."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		},
		{
			"linkId": "10500",
			"text": "Mobilité",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10501",
						"display": "Complètement immobile"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10502",
						"display": "Très limitée"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10503",
						"display": "Légèrement limitée"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "10504",
						"display": "Non limitée"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10500_helpText",
					"text": "Capacité de changer et de contrôler la position de son corps.",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "Capacité de changer et de contrôler la position de son corps.<br/><br/>- <b>Complètement immobile</b>: Incapable de faire le moindre changement de position de son corps ou de ses membres sans assistance.<br/><br/>- <b>Très limitée</b>: Fait occasionnellement de légers changements de position de son corps ou de ses membres mais est incapable de faire des changements fréquents ou importants de façon indépendante.<br/><br/>- <b>Légèrement limitée</b>: Fait de fréquents mais légers changements de position de son corps ou de ses membres de façon indépendante.<br/><br/>- <b>Non limitée</b>: Fait des changements de position importants et fréquents sans aide."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		},
		{
			"linkId": "10600",
			"text": "Nutrition",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10601",
						"display": "Très pauvre"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10602",
						"display": "Probablement inadéquate"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10603",
						"display": "Adéquate"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "10604",
						"display": "Excellente"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10600_helpText",
					"text": "Profil de l’alimentation habituelle.",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "Profil de l’alimentation habituelle.<br/><br/>- <b>Très pauvre</b>: Ne mange jamais un repas complet. Mange rarement plus du tiers de tout aliment offert. Mange deux portions ou moins de protéines (viandes ou produits laitiers) par jour. Boit peu de liquides. Ne prend pas de supplément nutritionnel liquide. -OU- Ne prend rien par la bouche et/ou reçoit une diète liquide ou une perfusion intraveineuse pendant plus de 5 jours.<br/><br/>- <b>Probablement inadéquate</b>: Mange rarement un repas complet et mange généralement que la moitié de tout aliment offert. L’apport de protéines comporte 3 portions de viandes ou de produits laitiers par jour. Prend occasionnellement un supplément nutritionnel. -OU- Reçoit une quantité insuffisante de liquide ou de gavage.<br/><br/>- <b>Adéquate</b>: Mange plus de la moitié de la plupart des repas. Mange un total de 4 portions de protéines (viandes, produits laitiers) chaque jour. Peut refuser à l’occasion un repas, mais prend habituellement un supplément nutritionnel s’il est offert. -OU- Est alimenté par gavage ou par alimentation parentérale totale qui répond probablement à la plupart des besoins nutritionnels.<br/><br/>- <b>Excellente</b>: Mange presque entièrement chaque repas. Ne refuse jamais un repas. Mange habituellement un total de 4 portions ou plus de viandes et de produits laitiers. Mange occasionnellement entre les repas. Un supplément nutritionnel n’est pas nécessaire."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		},
		{
			"linkId": "10700",
			"text": "Friction et cisaillement",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "10701",
						"display": "Problème"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "10702",
						"display": "Problème potentiel"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "10703",
						"display": "Aucun problème apparent"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				}
			],
			"item": [
				{
					"linkId": "10700_helpText",
					"text": "",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "- <b>Problème</b>: Le patient a besoin d’une aide modérée à maximale pour bouger. Il est impossible de le soulever complètement sans que sa peau frotte sur les draps. Il glisse fréquemment dans le lit ou au fauteuil, ce qui requiert d’être positionné fréquemment avec une aide maximale. La spasticité, les contractures ou l’agitation entraînent une friction presque constante.<br/><br/>- <b>Problème potentiel</b>: Le patient bouge faiblement ou requiert une aide minimale. Pendant un changement de position, la peau frotte probablement jusqu’à un certain degré contre les draps, le fauteuil, les contentions ou autres appareils. Il maintient la plupart du temps une assez bonne position au fauteuil ou au lit mais glisse à l’occasion.<br/><br/>- <b>Aucun problème apparent</b>: Le patient bouge de façon indépendante au lit ou au fauteuil et a suffisamment de force musculaire pour se soulever complètement pendant un changement de position. Il maintient en tout temps une bonne position dans le lit et au fauteuil."
							}
						]
					},
					"type": "display",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "help",
										"display": "Help-Button"
									}
								],
								"text": "Help-Button"
							}
						}
					]
				}
			]
		}
	]
}
